<div class="question-wrapper" *ngIf="question">
  <div
    class="card question-card"
    [ngClass]="{ invalid: isInvalid || isIncorrect }">
    <div class="preview-wrapper">
      <div class="d-flex justify-content-between">
        <div class="preview-question d-flex align-items-end">
          <app-safehtml [html]="question.question"></app-safehtml>
          <div *ngIf="question.required" class="text-danger ms-1">*</div>
        </div>
        <div
          *ngIf="
            viewState === viewStates.GRADED &&
            isIncorrect !== null &&
            showMissed
          "
          class="fs-18">
          <i
            *ngIf="!isIncorrect"
            class="bi bi-check-circle-fill text-success"></i>
          <i *ngIf="isIncorrect" class="bi bi-x-circle-fill text-danger"></i>
        </div>
      </div>
      <div *ngIf="question.helper_text" class="preview-description">
        <app-safehtml [html]="question.helper_text"></app-safehtml>
      </div>
      <div class="preview-body">
        @if(question.field_type === FieldTypes.TEXT || question.field_type ===
        FieldTypes.TEXTAREA ) {
        <app-proforms-question-answer-text
          [question]="question"
          [viewState]="viewState"></app-proforms-question-answer-text>
        } @else if(question.field_type === FieldTypes.RADIO ||
        question.field_type === FieldTypes.CHECKBOX ) {
        <app-proforms-question-answer-options
          [question]="question"
          [showAnswers]="showAnswers"
          [viewState]="viewState"></app-proforms-question-answer-options>
        } @else if (question.field_type === FieldTypes.ATTACHMENT) {
        <app-proforms-question-answer-attachment
          [question]="question"
          [viewState]="viewState" />
        } @else if (question.field_type === FieldTypes.SCALE) {
        <app-proforms-question-answer-scale
          [question]="question"
          [viewState]="viewState"></app-proforms-question-answer-scale>
        }
      </div>
      <div *ngIf="isInvalid" class="text-danger mt-4">
        <i class="bi bi-exclamation-circle me-2"></i>Field is required
      </div>
    </div>
  </div>
</div>
